let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gNO8R")).then(() => parcelRequire('j4I2L'));